import { render, staticRenderFns } from "./serviceSheetDetail.vue?vue&type=template&id=4e08d065&scoped=true"
import script from "./serviceSheetDetail.vue?vue&type=script&lang=js"
export * from "./serviceSheetDetail.vue?vue&type=script&lang=js"
import style0 from "./serviceSheetDetail.vue?vue&type=style&index=0&id=4e08d065&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e08d065",
  null
  
)

export default component.exports